// extracted by css-extract-rspack-plugin
export default {"layer":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WallpaperLayer-WallpaperLayer-module__layer-Wnn57e","image":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WallpaperLayer-WallpaperLayer-module__image-VEcGcm"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"layer\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WallpaperLayer-WallpaperLayer-module__layer-Wnn57e\",\"image\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WallpaperLayer-WallpaperLayer-module__image-VEcGcm\"}";
        // 1793874318443
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  